export default class Lead {
  transportTypeDesc: string;
  origin: string;
  destination: string;
  deliveryDateStr: string;
  cargoDesc: string;
  weightStr: string;
  budgetStr: string;
  reference: string;
}